<template>
  <el-aside
    :width="isCollapsed ? '60px' : '240px'"
    class="
      sticky
      top-0
      h-full
      min-h-screen
      shadow-xl
      flex flex-col
      bg-dark
      overflow-hidden
      pb-16
      z-20
      transition-all
      duration-100
    "
    :class="{
      active: navbar,
      'ml-2 right-0 rounded-tl-2xl rounded-bl-2xl': locale == 'fa',
      'mr-2 left-0 rounded-tr-2xl rounded-br-2xl': locale != 'fa',
    }"
  >
    <div
      v-if="!isCollapsed"
      class="flex flex-col items-start px-6 py-3 border-b border-gray-500"
    >
      <span class="text-sm text-white mr-3">
        {{ user_name == ' ' || !user_name ? 'ادمین' : user_name }}
      </span>
    </div>
    <el-menu
      :collapse="isCollapsed"
      :class="{
        'collapsed-menu': isCollapsed,
      }"
      class="border-0 flex-grow pt-2 relative pb-6 overflow-y-auto"
    >
      <div v-for="(item, index) in menu" :key="index">
        <router-link
          v-if="!item.submenu"
          class="el-menu-item"
          :to="{ name: item.title }"
        >
          <i
            v-if="item.icon != false"
            :class="item.icon"
            class="text-white"
          ></i>
          <span class="menu-title">{{ $t(item.title) }}</span>
        </router-link>
        <el-submenu v-else :index="index.toString()" class="">
          <template slot="title">
            <img
              v-if="item.img != false"
              class="external-icons"
              :src="require(`@/assets/images/${item.img}`)"
              alt=""
            />
            <i
              v-if="item.icon != false"
              :class="item.icon"
              class="text-white"
            ></i>
            <span class="menu-title">
              {{ $t(item.title) }}
            </span>
          </template>
          <el-menu-item-group class="group-submenu">
            <router-link
              v-for="(sub, i) in item.submenu"
              :key="i"
              class="el-menu-item"
              :to="{ name: sub.title }"
            >
              <span class="menu-title">
                {{ $t(sub.title) }}
              </span>
            </router-link>
          </el-menu-item-group>
        </el-submenu>
      </div>
      <el-menu-item>
        <router-link
          class="w-full flex items-center justify-center"
          :to="{ name: 'REMINDERS' }"
        >
          <i class="el-icon-alarm-clock text-white"></i>
          <span class="menu-title">
            {{ $t('REMINDERS') }}
          </span>
        </router-link>
      </el-menu-item>

      <el-menu-item @click="logout">
        <i class="el-icon-switch-button text-white"></i>
        <span class="menu-title">
          {{ $t('LOGOUT') }}
        </span>
      </el-menu-item>
    </el-menu>
    <span
      v-if="$i18n.locale == 'fa' && !isCollapsed"
      class="fixed bottom-4 right-8 text-white text-sm"
    >
      {{ date }}
      <span class="mx-2">|</span>
      {{ liveTime | toPersianNumber }}
    </span>
  </el-aside>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  data() {
    let options = { year: 'numeric', month: 'long', day: 'numeric' }
    let persianDate = new Date().toLocaleDateString('fa-IR', options)
    return {
      date: persianDate,
      liveTime: '',
      isCollapsed: true,
      menu: [
        {
          submenu: false,
          title: 'DASHBOARD',
          icon: 'el-icon-menu',
          img: false,
        },
        {
          submenu: false,
          title: 'REALTIME_REPORT',
          icon: 'el-icon-place',
          img: false,
        },
        {
          submenu: false,
          title: 'approvals_list',
          icon: 'el-icon-document-copy',
          img: false,
        },
        {
          title: 'DRIVERS_MANAGEMENT',
          icon: false,
          img: 'driver-management.svg',
          submenu: [
            {
              title: 'DRIVER_LIST',
            },
            {
              title: 'ADD_DRIVER',
            },
            {
              title: 'DRIVER_LEAVES_LIST',
            },
            {
              title: 'ADD_DRIVER_LEAVE',
            },
          ],
        },

        {
          title: 'VEHICLES_MANAGEMENT',
          icon: false,
          img: 'local_shipping.svg',
          submenu: [
            {
              title: 'VEHICLE_LIST',
            },
            {
              title: 'FINES_LIST',
            },
            {
              title: 'ADD_VEHICLE',
            },
            // {
            //   title: 'RULES_LIST',
            // },
            {
              title: 'tags_list',
            },
            {
              title: 'add_tag',
            },
          ],
        },

        // {
        //   title: 'LOCATIONS',
        //   icon: 'el-icon-location',
        //   img: false,
        //   submenu: [
        //     {
        //       title: 'LOCATIONS_LIST',
        //     },
        //     {
        //       title: 'LOCATIONS_ADD',
        //     },
        //   ],
        // },

        {
          title: 'GEOFENCES',
          icon: 'el-icon-map-location',
          img: false,
          submenu: [
            {
              title: 'GEOFENCE_LIST',
            },
            {
              title: 'ADD_GEOFENCE',
            },
          ],
        },

        {
          title: 'VEHICLE_SERVICE',
          icon: 'el-icon-odometer',
          img: false,
          submenu: [
            {
              title: 'VEHICLE_SERVICE_LIST',
            },
            {
              title: 'ADD_SERVICE',
            },
          ],
        },
        {
          title: 'REPORTS',
          icon: false,
          img: 'report.png',
          submenu: [
            // {
            //   title: 'HISTORY_ROUTES',
            // },
            // {
            //   title: 'HISTORY_ROUTES_LIST',
            // },
            {
              title: 'REPORT_OVERVIEW',
            },
            {
              title: 'REPORT_OVERVIEW_v2',
            },
            {
              title: 'DAILY_REPORT',
            },
            {
              title: 'REPORT_periodic',
            },
            {
              title: 'transactions_list',
            },
            {
              title: 'REALTIME_temperature',
            },
            // {
            //   title: 'REPORT_RULES_LIST',
            // },
            {
              title: 'GEOFENCE_RULES',
            },
            {
              title: 'PLANS_EVALUATION',
            },
            // {
            //   title: "HISTORY_REPORT_STOPS",
            // },
            {
              title: 'FLEET_EVENTS',
            },
            {
              title: 'HISTORY_REPORT_DRIVER',
            },
            {
              title: 'HISTORY_REPORT_HARDWARE',
            },
          ],
        },
      ],
    }
  },
  methods: {
    logout() {
      this.$store.dispatch('logout')
      this.$router.replace('/login')
    },
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed
    },
  },
  computed: {
    ...mapGetters(['navbar', 'user_name', 'locale']),
  },
  watch: {
    navbar(val) {
      if (!val) {
        const menuItems = document.querySelectorAll('.el-menu--vertical')
        menuItems.forEach((item) => {
          item.style.display = 'none'
        })
      }
    },
  },

  created() {
    var self = this

    setInterval(function () {
      let d = new Date()
      self.liveTime = d.getHours() + ':' + d.getMinutes() + ':' + d.getSeconds()
    }, 1000)
  },
}
</script>
<style>
.el-header {
  background-color: #b3c0d1;
  color: #333;
  line-height: 60px;
}

.el-aside {
  color: #333;
}

.el-menu {
  border-right: none !important;
}

.el-menu-item,
.el-submenu__title {
  padding-right: 25px !important;
  color: white !important;
  display: flex;
}

.bg-dark {
  /* background-image: url("~@/assets/images/pattern.png"); */
  background-color: #1c1d22 !important;
  background-position: 0px 0px, 0px 0;
  background-size: auto, cover;
  max-height: 80vh;
  overflow-y: auto;
}

.external-icons {
  margin-left: 8px;
  width: 20px;
  margin-right: 8px;
}

.el-menu-item-group__title {
  display: none;
}
.collapsed-menu .menu-title {
  display: none;
  transition: all 0.3s;
}
.collapsed-menu .el-menu-item,
.collapsed-menu .el-submenu__title {
  align-items: center;
  justify-content: center;
  padding-right: 15px !important;
  transition: all 0.3s;
}
body .collapsed-menu .el-submenu__icon-arrow {
  display: none;
}
.el-menu--popup {
  border-radius: 10px;
}
.el-menu--popup .el-menu-item-group > ul {
  margin: 0 !important;
}
.collapsed-menu .external-icons {
  flex-shrink: 0;
  margin: 0;
  width: 83%;
}
.collapsed-menu .el-submenu [class^='text-white'] {
  font-size: 22px;
}
.el-menu-item-group__title:empty {
  display: none;
}
.collapse-button {
  position: absolute;
  left: 17px;
  bottom: 11px;
}
.collapse-button i {
  background-color: #91939a;
  border-radius: 50%;
  padding: 5px;
}
</style>
